// extracted by mini-css-extract-plugin
module.exports = {"title":"modal_title__m_LN1","description":"modal_description__58_Xv","footerContainer":"modal_footerContainer__uZUO8","mobileHeaderTitle":"modal_mobileHeaderTitle__zEOg4"};